import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject, signal, viewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { BlockableDiv } from '../../../../shared/controls/blockable-div/blockable-div.component';
import { BaseDetailComponent } from '../../../../common/base-detail.component';
import { DeletionResult, Document } from '../../../../generated/generated-types';
import { FormlyFillHeightListHostDirective } from '../../../custom-formly/formly-tabs/formly-fill-height-list-host.directive';
import { DocumentService } from '../../../documents/services/document.service';
import { ReportHistoryListComponent } from '../report-history-list/report-history-list.component';

@Component({
  selector: 'app-formly-report-history',
  templateUrl: './formly-report-history.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [FormlyFillHeightListHostDirective],
  standalone: true,
  imports: [
    ReportHistoryListComponent,
    BlockableDiv,
    TranslatePipe,
    ButtonModule,
    TooltipModule,
  ]
})
export class FormlyReportHistoryComponent extends FieldType<FieldTypeConfig> {
  private readonly documentService = inject(DocumentService);
  private readonly cdRef = inject(ChangeDetectorRef);
  private readonly reportHistoryListComponent = viewChild(ReportHistoryListComponent);
  private readonly destroyRef = inject(DestroyRef);

  isSaving = signal(false);

  get isBlocked(): boolean {
    return !this.model?.id;
  }

  constructor() {
    super();
    this.documentService.onDeleteDocumentAssetAction$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(({ documentId, result }) => {
      if (result.result === DeletionResult.DELETED && documentId === this.model?.id) {
        this.reportHistoryListComponent()?.refresh();
      }
    });
  }

  checkIfCanSave(): boolean {
    const component = this.options.formState.detailComponent as BaseDetailComponent<Document>;
    return component.detailForm.invalid;
  }

  async saveToUnlockEditMode(): Promise<void> {
    const component = this.options.formState.detailComponent as BaseDetailComponent<Document>;
    if (!component) {
      console.error('No detail component found to save Document');
      return;
    }

    this.isSaving.set(true);
    this.cdRef.detectChanges();

    try {
      await component.save();
    } finally {
      this.isSaving.set(false);
      this.cdRef.detectChanges();
    }
  }
}
